export const Header = (function () {
    "use strict";

    let $menu, $secondaryMenu, $menuButton, $subMenuParent, $subMenuItem, $body, $searchToggle, $searchForm;

    function init() {
        $menu = $(".site-header__nav .nav-items");
        $secondaryMenu = $(".site-header__nav .secondary-menu");
        $menuButton = $(".mobile-menu-button");
        $body = $("body");
        $subMenuParent = $(".site-header .menu-item-has-children");
        $subMenuItem = $(".site-header .sub-menu a");
        $searchToggle = $(".site-header .toggle-search");
        $searchForm = $(".site-header .search-form");

        events();
    }

    function events() {
        $menuButton.click(function () {
            if ($menu.hasClass("open")) {
                $body.removeClass("mobile-menu-open");
                $menu.removeClass("open");
                $secondaryMenu.removeClass("open");
                $menuButton.removeClass("open").attr("aria-expanded", "false");
            } else {
                $body.addClass("mobile-menu-open");
                $menu.addClass("open");
                $secondaryMenu.addClass("open");
                $menuButton.addClass("open").attr("aria-expanded", "true");
            }
        });

        $searchToggle.click(function (e) {
            console.log("CLICK");
            e.preventDefault();
            if ($searchForm.hasClass("show")) {
                $searchForm.removeClass("show");
            } else {
                $searchForm.addClass("show");
            }
        });
    }

    return {
        init: init,
    };
})();
